import React, { useState } from 'react';
import { IPartner } from 'types';
import { grid, itemWrap } from './styles';
import Item from './Item';
import Modal from '../Modal';
import { FileServiceQuery, PartnerQuery } from 'queries';
import { DEFAULT_ERROR_MESSAGE } from 'data/message';
import { toast } from 'react-toastify';

function List() {
  const { data, isLoading } = PartnerQuery.useGetAll();
  const [selectedItem, setSelectedItem] = useState<IPartner | null>(null);
  const [editItem, setEditItem] = useState<IPartner | null>(null);
  const { mutateAsync: update } = PartnerQuery.useUpdate();
  const { handleUploadd: upload } = FileServiceQuery.useUpload();

  const handleSave = async (partner: IPartner, newFile?: File | null) => {
    if (!editItem) return;
    let thumbnail = partner.thumbnail;
    if (newFile) {
      const res = await upload(newFile);
      if (!res) return;
      thumbnail = res.data.url;
    }
    try {
      await update({
        ...partner,
        thumbnail,
        id: editItem.id,
        isNewFile: !!newFile,
      });
      toast.success('파트너가 수정되었습니다.');
    } catch {
      toast.error(DEFAULT_ERROR_MESSAGE);
    }
    setEditItem(null);
  };

  if (isLoading) return null;

  return (
    <>
      <div css={grid}>
        {data.map((item: IPartner) => (
          <div key={item.id} css={itemWrap}>
            <Item
              item={item}
              selectedItem={selectedItem}
              setSelectedItem={setSelectedItem}
              setEditItem={setEditItem}
            />
          </div>
        ))}
      </div>
      {editItem && (
        <Modal
          partner={editItem}
          onClose={() => setEditItem(null)}
          onSave={handleSave}
        />
      )}
    </>
  );
}

export default List;
